/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'product-recommendations';
const productDetailServletEndpoint = '/bin/rockwell-automation/product-details';
const productDetailsPage = '/products/details.';
export class ProductRecommendations extends Component {
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        productTemplate: this.element.querySelector(`.${componentName}__product-template`),
        basedOnViewsList: this.element.querySelector(`.${componentName}__content--based-on-views .${componentName}__products`),
        bestSellingList: this.element.querySelector(`.${componentName}__content--best-selling .${componentName}__products`),
        loadingSkeletonsBasedOnViews: this.element.querySelectorAll(`.${componentName}__content--based-on-views .${componentName}__loading-skeleton`),
        loadingSkeletonsBestSelling: this.element.querySelectorAll(`.${componentName}__content--best-selling .${componentName}__loading-skeleton`),
    };

    constants = {
        productsToDisplay: 4,
        defaultImage: 'https://www.rockwellautomation.com/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/image_unavailable.svg',
        locale: document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us',
        bestSellingCatalogNumbers: this.element.querySelector(`.${componentName}__content--best-selling`).dataset.catalogNumbers,
        appType: this.element.querySelector(`.${componentName}__container`).dataset.appType,
        productImagePrefix: 'https://configurator.rockwellautomation.com/api/Doc/',
        productSet: [],
        language: 'en',
    };

    getBasedOnViewsProducts = async () => {
        if (!window.localStorage.getItem('pira-pz-recomms')) {
            return { productResultsBasedOnViews: [], productCategoryBasedOnViews: '' };
        }
        let recommendedPageList = [];
        try {
            recommendedPageList = JSON.parse(window.localStorage.getItem('pira-pz-recomms'));
        } catch (error) {
            console.warn('Error parsing recommended page list:', error);
        }
        const productResults = [];
        const recommendedCategories = [];
        while (recommendedPageList.length > 0 && productResults.length < this.constants.productsToDisplay) {
            let recommendedPage = recommendedPageList.shift();
            if (!recommendedPage.page) {
                continue;
            }
            if (recommendedPage.page.includes('/products/details.')) {
                this.constants.productSet.push(recommendedPage.page.split('/products/details.')[1].replace('.html', ''));
                recommendedPage = await this.getProductMetadata(recommendedPage.page);
                if (!recommendedPage.title) {
                    continue;
                }
                productResults.push(recommendedPage);
            }
        }
        this.toggleAiTranslationsDisclaimer(productResults);
        return { productResultsBasedOnViews: productResults.slice(0, this.constants.productsToDisplay), productCategoriesBasedOnViews: recommendedCategories };
    };

    getBestSellingBasedOnViews = async () => {
        if (!window.localStorage.getItem('pira-pz-recomms')) {
            return [];
        }
        let recommendedPageList = [];
        try {
            recommendedPageList = JSON.parse(window.localStorage.getItem('pira-pz-recomms'));
        } catch (error) {
            console.warn('Error parsing recommended page list:', error);
        }
        const productResults = [];
        while (recommendedPageList.length > 0 && productResults.length < this.constants.productsToDisplay) {
            let recommendedPage = recommendedPageList.shift();
            if (!recommendedPage.page) {
                continue;
            }
            if (recommendedPage.page.includes('/products/details.') && recommendedPage.best) {
                const catalogNumber = recommendedPage.page.split('/products/details.')[1].replace('.html', '');
                if (!this.constants.productSet.includes(catalogNumber)) {
                    recommendedPage = await this.getProductMetadata(recommendedPage.page);
                    if (!recommendedPage.title) {
                        continue;
                    }
                    productResults.push(recommendedPage);
                    this.constants.productSet.push(catalogNumber);
                }
            }
        }
        this.toggleAiTranslationsDisclaimer(productResults);
        return productResults;
    };

    getBestSellingProducts = async () => {
        const bestSellingProducts = [];
        const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
        const countryCode = locale.split('-')[1];

        // Get best selling products from catalog numbers
        if (this.constants.bestSellingCatalogNumbers) {
            try {
                const response = await fetch(`${productDetailServletEndpoint}?catalogNumber=${this.constants.bestSellingCatalogNumbers}&app=${this.constants.appType}&countryCode=${countryCode}`);
                const responseBuffer = await response.arrayBuffer();
                const responseString = new TextDecoder('UTF-8').decode(responseBuffer);
                const responseJson = JSON.parse(responseString);
                if (this.constants.language !== 'en') {
                    this.toggleAiTranslationsDisclaimer(responseJson);
                }
                if (responseJson.length) {
                    responseJson.forEach((product) => {
                        bestSellingProducts.push({
                            title: this.getTranslatableProductField(product, 'names', 'names_value', '', this.constants.language) || product.title,
                            description: this.getTranslatableProductField(product, 'Rdescription', 'R_description', '', this.constants.language) || this.getTranslatableProductField(product, 'technicalDescription', 'technicalDescription_value', '', this.constants.language),
                            imageUrl: product.picture_url || this.constants.defaultImage,
                            page: productDetailsPage + product.catalogNumber + '.html',
                        });
                        this.constants.productSet.push(product.catalogNumber);
                    });
                } else {
                    bestSellingProducts.push({
                        title: this.getTranslatableProductField(responseJson, 'names', 'names_value', '', this.constants.language) || responseJson.title,
                        description: this.getTranslatableProductField(responseJson, 'Rdescription', 'R_description', '', this.constants.language) || this.getTranslatableProductField(responseJson, 'technicalDescription', 'technicalDescription_value', '', this.constants.language),
                        imageUrl: responseJson.picture_url || this.constants.defaultImage,
                        page: productDetailsPage + responseJson.catalogNumber + '.html',
                    });
                    this.constants.productSet.push(responseJson.catalogNumber);
                }
            } catch (error) {
                console.warn('Error fetching best selling products:', error);
            }
        }

        const numRemainingProducts = this.constants.productsToDisplay - bestSellingProducts.length;

        // Get remaining best selling products
        if (numRemainingProducts > 0) {
            try {
                const response = await fetch(`${productDetailServletEndpoint}?categoryIds=all&fields=all&sortBy=salesSort--salesOrg_preferredAvailability&startIndex=0&numResults=${numRemainingProducts}&app=${this.constants.appType}&countryCode=${countryCode}`);
                const responseBuffer = await response.arrayBuffer();
                const responseString = new TextDecoder('UTF-8').decode(responseBuffer);
                const responseJson = JSON.parse(responseString);
                if (this.constants.language !== 'en') {
                    this.toggleAiTranslationsDisclaimer(responseJson.docs);
                }
                responseJson.docs.forEach((product) => {
                    if (!this.constants.productSet.includes(product.catalogNumber)) {
                        bestSellingProducts.push({
                            title: this.getTranslatableProductField(product, 'names', 'names_value', '', this.constants.language) || product.title,
                            description: this.getTranslatableProductField(product, 'Rdescription', 'R_description', '', this.constants.language) || this.getTranslatableProductField(product, 'technicalDescription', 'technicalDescription_value', '', this.constants.language),
                            imageUrl: product.picture_url || this.constants.defaultImage,
                            page: productDetailsPage + product.catalogNumber + '.html',
                        });
                        this.constants.productSet.push(product.catalogNumber);
                    }
                });
            } catch (error) {
                console.warn('Error fetching best selling products:', error);
            }
        }

        if (bestSellingProducts.length > this.constants.productsToDisplay) {
            bestSellingProducts.splice(this.constants.productsToDisplay);
        }
        return bestSellingProducts;
    };

    getProductMetadata = async (productPage) => {
        const recommendedPage = {
            page: productPage,
            title: '',
            description: '',
            imageUrl: '',
            page: '',
            best: false,
            isAiTranslated: false,
        };
        let productDetailPageUrl = `/${this.constants.locale}${productPage}`;
        if (window.location.pathname.startsWith('/content/rockwell-automation/global/en')) {
            productDetailPageUrl = `/content/rockwell-automation/global/en${productPage}`;
        } else if (window.location.pathname.startsWith('/content/rockwell-automation/global/')) {
            const locale = window.location.pathname.split('/')[4] + '/' + window.location.pathname.split('/')[5];
            productDetailPageUrl = `/content/rockwell-automation/global/${locale}${productPage}`;
        }
        const productResponse = await fetch(productDetailPageUrl);
        if (productResponse.ok) {
            const productDocument = new DOMParser().parseFromString(await productResponse.text(), 'text/html');
            const productMetadata = productDocument.querySelector('#product-personalization-schema');
            if (productMetadata) {
                const productMetadataJson = JSON.parse(productMetadata.textContent.replace('window.pagePersonalizationSummary = ', ''));
                recommendedPage.title = productMetadataJson.title;
                recommendedPage.description = productMetadataJson.description;
                recommendedPage.imageUrl = productMetadataJson.imageUrl;
                recommendedPage.page = `${productPage}`;
                recommendedPage.best = productMetadataJson.best;
                recommendedPage.isAiTranslated = productMetadataJson.isAiTranslated;
            }
        }
        return recommendedPage;
    };

    createProductElement = async (product) => {
        const productElement = this.elements.productTemplate.cloneNode(true);
        productElement.classList.remove(`${componentName}__product-template`);
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-title`), product.title);
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-description`), product.description);
        productElement.querySelector(`.${componentName}__product-image`).addEventListener('error', () => {
            productElement.querySelector(`.${componentName}__product-image`).src = this.constants.defaultImage;
        });
        if (product.picture_url) {
            productElement.querySelector(`.${componentName}__product-image`).src = product.picture_url.includes('/') ? product.picture_url : this.constants.productImagePrefix + product.picture_url;
        } else if (product.image) {
            productElement.querySelector(`.${componentName}__product-image`).src = product.image.includes('/') ? product.image : this.constants.productImagePrefix + product.image;
        } else if (product.imageUrl && !product.imageUrl.endsWith('.html')) {
            productElement.querySelector(`.${componentName}__product-image`).src = product.imageUrl;
        } else if (product.imageUrl && product.imageUrl.endsWith('.html')) {
            productElement.querySelector(`.${componentName}__product-image`).src = await this.getProductImage(`${window.location.origin}/en-us${product.imageUrl}`);
        } else {
            productElement.querySelector(`.${componentName}__product-image`).src = this.constants.defaultImage;
        }
        productElement.querySelector(`.${componentName}__product-image`).alt = product.title;
        const linkElement = productElement.querySelector(`.${componentName}__product-link`);
        if (linkElement) {
            linkElement.href = `/${this.constants.locale}${product.page}`;
            linkElement.ariaLabel = product.title;
        }
        return productElement;
    };

    getProductImage = async (productUrl) => {
        try {
            const response = await fetch(productUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'text/html; charset=UTF-8',
                },
            });
            const responseText = await response.text();
            const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
            const productImage = responseDocument.querySelector('img');
            return productImage ? productImage.src : this.constants.defaultImage;
        } catch (error) {
            console.warn('Error fetching product image:', error);
            return this.constants.defaultImage;
        }
    };

    addTextContentOrRemove = (element, textContent) => {
        if (textContent) {
            element.textContent += textContent;
        } else {
            element.remove();
        }
    };

    getTranslatableProductField = (productJson, field, flattenedField, defaultValue, language) => {
        if (productJson[field] && productJson[field] instanceof Array) {
            try {
                for (let i = 0; i < productJson[field].length; i++) {
                    if (productJson[field][i].isocode.toLowerCase() === language.toLowerCase()) {
                        return productJson[field][i].value;
                    }
                }
            } catch (error) {
                console.warn(`Error getting translatable product field ${field} for language ${language}:`, error);
            }
            if (language.toLowerCase() !== 'en') {
                return this.getTranslatableProductField(productJson, field, flattenedField, defaultValue, 'en');
            }
        }
        return productJson[flattenedField] ? productJson[flattenedField].value : defaultValue;
    };

    toggleAiTranslationsDisclaimer = (products) => {
        const aiTranslationsDisclaimer = document.querySelector('.ai-translations-disclaimer-text');
        if (aiTranslationsDisclaimer && (products.some((product) => product.translate_time) || products.some((product) => product.isAiTranslated))) {
            aiTranslationsDisclaimer.classList.remove('hidden');
        }
    };

    initDom = async () => {
        if (document.documentElement.lang === 'zh-TW') {
            this.constants.language = 'zh-tw';
        } else if (document.documentElement.lang) {
            this.constants.language = document.documentElement.lang.split('-')[0].toLocaleLowerCase();
        }
        const { productResultsBasedOnViews, productCategoriesBasedOnViews } = await this.getBasedOnViewsProducts();
        let productResultsBestSelling = [];
        const productResultsBestSellingBasedOnViews = await this.getBestSellingBasedOnViews();
        if (productResultsBestSellingBasedOnViews.length < this.constants.productsToDisplay) {
            const productResultsBestSellingAll = await this.getBestSellingProducts();
            productResultsBestSellingAll.splice((this.constants.productsToDisplay - productResultsBestSellingBasedOnViews.length));
            productResultsBestSelling = [...productResultsBestSellingBasedOnViews, ...productResultsBestSellingAll];
        } else {
            productResultsBestSelling = productResultsBestSellingBasedOnViews;
        }

        if (productResultsBasedOnViews.length > 0) {
            productResultsBasedOnViews.forEach(async (product) => {
                const productElement = await this.createProductElement(product);
                this.elements.basedOnViewsList.appendChild(productElement);
            });
        } else {
            this.elements.container.querySelector(`.${componentName}__content--based-on-views`).remove();
        }
        Array.from(this.elements.loadingSkeletonsBasedOnViews).forEach((loadingSkeleton) => {
            loadingSkeleton.remove();
        });
        if (productResultsBestSelling.length > 0) {
            productResultsBestSelling.forEach(async (product) => {
                const productElement = await this.createProductElement(product);
                this.elements.bestSellingList.appendChild(productElement);
            });
        } else {
            this.elements.container.querySelector(`.${componentName}__content--best-selling`).remove();
        }
        Array.from(this.elements.loadingSkeletonsBestSelling).forEach((loadingSkeleton) => {
            loadingSkeleton.remove();
        });
    };

    /**
     * Initialize Component
     */
    init = () => {
        this.initDom();
    };
}

registerComponent(`.${componentName}`, ProductRecommendations);
